import React from 'react';
import ConstructorForm from '../components/ConstructorForm';
import { useOutletContext } from 'react-router-dom';

const ConstructorFormPage = () => {
    const outletContext = useOutletContext();
    const { usuario } = outletContext || {};
    return (
        <div>
            <ConstructorForm usuario={usuario} />
        </div>
    );
};

export default ConstructorFormPage; 